/* Guía de tallas nativa — tabs, chips, ventana de 3 columnas y cm/pulgadas.
   Sin dependencias. La apertura/cierre del drawer la maneja el theme. */
(function () {
  'use strict';

  var WINDOW_SIZE = 3;

  /* Compara tallas ignorando separadores: la opcion del PDP viene como
     "32 EUR / 0 US" y en el admin la barra parte el campo de lista, asi que
     alli toca escribirla de otra forma ("32 EUR - 0 US"). Normalizando a solo
     alfanumerico las dos caen en "32eur0us" y la preseleccion sigue cuadrando. */
  function norm(v) {
    return (v || '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  /* Convierte cada número dentro del texto, respetando rangos ("86-90"). */
  function toInches(text) {
    return text.replace(/\d+([.,]\d+)?/g, function (n) {
      var val = parseFloat(n.replace(',', '.')) / 2.54;
      return (Math.round(val * 10) / 10).toString().replace('.', ',');
    });
  }

  function Panel(el) {
    this.el = el;
    this.chips = Array.prototype.slice.call(el.querySelectorAll('[data-gt-chip]'));
    this.table = el.querySelector('[data-gt-table]');
    this.unitsBtn = el.querySelector('[data-gt-units]');
    this.index = 0;
    this.inches = false;
    this.bind();
    this.select(0);
  }

  Panel.prototype.bind = function () {
    var self = this;

    this.chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        /* El chip no debe tocar la variante del PDP. */
        e.preventDefault();
        e.stopPropagation();
        self.select(parseInt(chip.getAttribute('data-gt-chip'), 10));
      });
    });

    if (this.unitsBtn) {
      this.unitsBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.setUnits(!self.inches);
      });
    }
  };

  /* Ventana deslizante: muestra 3 columnas a partir del índice activo,
     sin salirse del array cuando se elige una de las últimas tallas. */
  Panel.prototype.select = function (index) {
    if (!this.chips.length) return;

    var total = this.chips.length;
    if (isNaN(index) || index < 0) index = 0;
    if (index > total - 1) index = total - 1;
    this.index = index;

    var start = Math.min(index, Math.max(total - WINDOW_SIZE, 0));
    var end = start + WINDOW_SIZE - 1;

    this.chips.forEach(function (chip, i) {
      var active = i === index;
      chip.classList.toggle('is--active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (!this.table) return;
    var cells = this.table.querySelectorAll('[data-gt-col]');
    Array.prototype.forEach.call(cells, function (cell) {
      var col = parseInt(cell.getAttribute('data-gt-col'), 10);
      var visible = col >= start && col <= end;
      cell.hidden = !visible;
      cell.classList.toggle('is--current', col === index);
    });
  };

  Panel.prototype.setUnits = function (inches) {
    this.inches = inches;
    this.el.classList.toggle('is--inches', inches);

    if (this.unitsBtn) {
      this.unitsBtn.setAttribute('aria-pressed', inches ? 'true' : 'false');
      var toIn = this.unitsBtn.querySelector('[data-gt-units-to-in]');
      var toCm = this.unitsBtn.querySelector('[data-gt-units-to-cm]');
      if (toIn) toIn.hidden = inches;
      if (toCm) toCm.hidden = !inches;
    }

    if (!this.table) return;
    var cells = this.table.querySelectorAll('[data-gt-cm]');
    Array.prototype.forEach.call(cells, function (cell) {
      var cm = cell.getAttribute('data-gt-cm');
      cell.textContent = inches ? toInches(cm) : cm;
    });
  };

  /* Talla elegida en el PDP, para preseleccionar el chip al abrir. */
  function selectedPdpSize() {
    var groups = document.querySelectorAll('[data-swatch-option]');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var isSize =
        group.classList.contains('fitit-sizes') ||
        /talla|size|größe/i.test(group.className);
      if (!isSize) continue;
      var selected = group.querySelector('[data-swatch-item].is--selected');
      if (selected) return selected.getAttribute('data-value');
    }
    return null;
  }

  function Guide(root) {
    var self = this;
    this.root = root;
    this.panels = Array.prototype.slice
      .call(root.querySelectorAll('[data-gt-panel-body]'))
      .map(function (el) {
        return new Panel(el);
      });

    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gt-tab]'));
    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        self.showTab(tab.getAttribute('data-gt-tab'));
      });
    });

    this.syncFromPdp();
    this.trapFocus();

    /* El drawer del theme no emite evento propio de apertura: observamos
       aria-hidden, que es lo que el theme conmuta al abrir. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (root.getAttribute('aria-hidden') === 'false') {
          self.syncFromPdp();
          var close = root.querySelector('[data-drawer-close]');
          if (close) close.focus();
        }
      }).observe(root, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  /* El drawer del theme cierra con Esc y overlay, pero no retiene el foco. */
  Guide.prototype.trapFocus = function () {
    var root = this.root;
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;

      var focusables = root.querySelectorAll(
        'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      );
      var visible = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null;
      });
      if (!visible.length) return;

      var first = visible[0];
      var last = visible[visible.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  };

  Guide.prototype.showTab = function (name) {
    this.tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-gt-tab') === name;
      tab.classList.toggle('is--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-gt-panel]'), function (panel) {
      var active = panel.getAttribute('data-gt-panel') === name;
      panel.classList.toggle('is--active', active);
      panel.hidden = !active;
    });
  };

  Guide.prototype.syncFromPdp = function () {
    var size = norm(selectedPdpSize());
    if (!size) return;

    this.panels.forEach(function (panel) {
      for (var i = 0; i < panel.chips.length; i++) {
        var chip = panel.chips[i];
        /* La talla del PDP puede venir como número (38) o como equivalencia (M). */
        if (
          norm(chip.getAttribute('data-gt-value')) === size ||
          norm(chip.getAttribute('data-gt-alt')) === size
        ) {
          panel.select(i);
          return;
        }
      }
    });
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gt-root]'), function (root) {
      if (root.__gtReady) return;
      root.__gtReady = true;
      new Guide(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
